export const navLinks = [
  { name: 'Home', href: '/' },
  { name: 'Appointment', href: '/appointment' },
  { name: 'Services', href: '/services' },
  { 
    name: 'Visa Applications', 
    href: '/visa',
    dropdown: [
      { name: 'All Visa Types', href: '/visa' },
      { name: 'Student Visa', href: '/visa/student' },
      { name: 'Work Visa', href: '/visa/work' },
      { name: 'Visitor Visa', href: '/visa/visitor' },
    ]
  },
  { name: 'Israel Pilgrimage', href: '/israel-pilgrimage-2026' },
  { name: 'Tour Registration', href: '/tour-registration' },
  { name: 'About', href: '/about' },
];

export const services = [
  // Travel & Tours (primary)
  {
    id: 1,
    category: 'travel',
    title: 'International Travel & Tours',
    description: 'Curated multi-country tours and travel packages designed for smooth, memorable journeys.',
    href: '/services',
    icon: 'globe'
  },
  {
    id: 2,
    category: 'travel',
    title: 'Car Rental Assistance',
    description: 'Help tourists find reliable car rentals and local transport options at their destination.',
    href: '/services',
    icon: 'car'
  },
  {
    id: 3,
    category: 'travel',
    title: 'Air Ticketing',
    description: 'Affordable flight bookings and itinerary support for destinations worldwide.',
    href: '/appointment',
    icon: 'plane'
  },
  {
    id: 4,
    category: 'travel',
    title: 'Airport Transfers',
    description: 'Airport pickup and drop-off arrangements so arrivals and departures stay stress-free.',
    href: '/appointment',
    icon: 'map-pin'
  },
  {
    id: 5,
    category: 'travel',
    title: 'Hotel & Stay Booking',
    description: 'Assistance finding comfortable hotels and stays that match your budget and trip style.',
    href: '/appointment',
    icon: 'building'
  },
  {
    id: 6,
    category: 'travel',
    title: 'Custom Trip Planning',
    description: 'Personalized itineraries covering sightseeing, transfers, and day-to-day travel needs.',
    href: '/appointment',
    icon: 'compass'
  },
  {
    id: 7,
    category: 'travel',
    title: 'Holy Land Israel Tour',
    description: 'Faith-based pilgrimage to Israel, October 6-14, 2026. Registration is currently closed.',
    href: '/israel-pilgrimage-2026',
    icon: 'landmark'
  },
  // Education & Academia (secondary)
  {
    id: 8,
    category: 'education',
    title: 'Student Visa Application',
    description: 'Comprehensive assistance for student visa applications to study abroad.',
    href: '/visa/student',
    icon: 'graduation-cap'
  },
  {
    id: 9,
    category: 'education',
    title: 'Visitor Visa Application',
    description: 'Expert guidance for tourist and visitor visa applications.',
    href: '/visa/visitor',
    icon: 'passport'
  },
  {
    id: 10,
    category: 'education',
    title: 'Work Permit Application',
    description: 'Professional support for work permit applications and documentation.',
    href: '/visa/work',
    icon: 'briefcase'
  },
  {
    id: 11,
    category: 'education',
    title: 'Express Entry for Canada',
    description: 'Complete Express Entry program guidance for Canadian immigration.',
    href: '/services',
    icon: 'canada'
  },
  {
    id: 12,
    category: 'education',
    title: 'University Admission Guidance',
    description: 'Personalized assistance for university applications and admissions.',
    href: '/services',
    icon: 'book-open'
  },
  {
    id: 13,
    category: 'education',
    title: 'Document Preparation',
    description: 'Professional help with visa and immigration document preparation.',
    href: '/services',
    icon: 'file-text'
  },
  {
    id: 14,
    category: 'education',
    title: 'Immigration Consultation',
    description: 'Expert immigration consultation and assessment services.',
    href: '/appointment',
    icon: 'users'
  },
  {
    id: 15,
    category: 'education',
    title: 'Language Test Preparation',
    description: 'Guidance for IELTS, TOEFL, and other language proficiency tests.',
    href: '/services',
    icon: 'languages'
  },
  {
    id: 16,
    category: 'education',
    title: 'Scholarship Applications',
    description: 'Assistance with finding and applying for international scholarships.',
    href: '/services',
    icon: 'award'
  }
];

export const stats = [
  { number: '40+', label: 'Countries' },
  { number: '4,070+', label: 'Clients assisted' },
  { number: '283+', label: 'University partners' }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Travel planning first',
    description: 'Tours, flights, stays, car rentals, and transfers with clear, practical next steps.',
    icon: 'visa'
  },
  {
    id: 2,
    title: 'Destinations that matter',
    description: 'Multi-country itineraries and trip support shaped around how you actually travel.',
    icon: 'global'
  },
  {
    id: 3,
    title: 'Education when needed',
    description: 'Visa, admission, and scholarship guidance available alongside travel services.',
    icon: 'admission'
  }
];

export const testimonials = [
  {
    id: 1,
    country: 'Germany',
    name: 'Lisa K.',
    image: '',
    testimonial: 'Cardx Academia and Travel Tours helped me secure admission to a university in Germany and assisted with booking my Germany visa appointment. Their professionalism and attention to detail made the entire process easy and stress-free. I am incredibly thankful for their support and highly recommend their services to anyone seeking help with international education and visas',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 2,
    country: 'Canada',
    name: 'Salomon Niyitanga',
    image: '', // No profile picture
    testimonial: 'I am beyond grateful to Cardx Academia and Travel Tours for helping me secure my Canadian student visa to study at Algonquin College and book my flight from Rwanda to Ottawa. Their expertise made the entire process smooth and stress free. From guiding me through the visa application to finding the best flight deal, their support was exceptional. I highly recommend their services to anyone looking for a seamless journey to study abroad.',
    type: 'video',
    videoUrl: '/videos/salomon.mp4', // Local video file
    thumbnail: '',
    instagramEmbed: false
  },
  {
    id: 3,
    country: 'Canada',
    name: 'Olivier Niyiduhaye',
    image: '', // No profile picture
    testimonial: 'I am deeply thankful to Cardx Academia and Travel Tours for their outstanding support throughout my visa application process. With their guidance, I successfully secured my Canadian student visa and am now ready to begin my studies in Canada. Their team was incredibly helpful, from preparing my documents to following up with IRCC and ensuring every step went smoothly.',
    type: 'video',
    videoUrl: '/videos/Olivier.mp4', // Local video file
    thumbnail: '',
    instagramEmbed: false
  },
  {
    id: 4,
    country: 'Israel',
    name: 'Christine Twambazimana',
    image: '', // No profile picture
    testimonial: 'Thanks to Cardx Academia and Travel Tours, I secured full scholarship to Reichman University in Israel and successfully obtained my student visa. Their guidance throughout the scholarship application and visa process was invaluable. I felt supported every step of the way, and I couldn\'t have done it without their expert assistance. I highly recommend them to anyone pursuing international education',
    type: 'video',
    videoUrl: '/videos/Christine.mp4', // Local video file
    thumbnail: '',
    instagramEmbed: false,
    scholarship: true
  },
  {
    id: 5,
    country: 'Student Visa Success',
    name: 'Theogene',
    image: '', // No profile picture
    testimonial: 'We are proud to announce another remarkable success from Cardx Academia. Our client, Theogene, has officially secured his student visa to pursue his higher education abroad. This milestone is a reflection of his commitment and our team\'s dedication to guiding students through every step of their study-abroad journey, from admissions and visa processing to pre-departure preparation. With our support, Theogene also received a scholarship to help fund his educational journey, making his dream of studying abroad a reality.',
    type: 'video',
    videoUrl: '/videos/Theogene.mp4', // Local video file
    thumbnail: '', // Will use video poster
    scholarship: true, // Indicates they received a scholarship
    instagramEmbed: false // Using local video file
  },
  {
    id: 6,
    country: 'Israel',
    name: 'Mukamisha',
    image: '',
    testimonial: 'I am incredibly grateful to Cardx Academia and Travel Tours for their exceptional support throughout my journey. With their guidance and expertise, I successfully secured a master scholarship to Israel, obtained my student visa, and received admission to my chosen university. Their team provided comprehensive assistance every step of the way, from scholarship applications to visa processing. I couldn\'t have achieved this without their professional support and dedication. I highly recommend Cardx Academia to anyone pursuing higher education opportunities abroad.',
    type: 'video',
    videoUrl: '/videos/Mukamisha.mp4',
    thumbnail: '',
    instagramEmbed: false,
    scholarship: true
  },
  {
    id: 7,
    country: 'USA',
    name: 'Jean Paul Uwimana',
    image: '',
    testimonial: 'Cardx Academia made my dream of studying in the United States a reality. They helped me secure admission to a top university and guided me through the entire visa process. Their team was always available to answer my questions and provided excellent support throughout. I am now pursuing my master\'s degree in Computer Science thanks to their expertise.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 8,
    country: 'Canada',
    name: 'Marie Claire Umutoni',
    image: '',
    testimonial: 'I am extremely grateful to Cardx Academia for helping me obtain my Canadian student visa. The process seemed overwhelming at first, but their team broke it down into manageable steps and supported me every step of the way. They also helped me find affordable flights and prepare all necessary documents. Highly recommended!',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 9,
    country: 'Germany',
    name: 'Emmanuel Nkurunziza',
    image: '',
    testimonial: 'Thanks to Cardx Academia, I successfully secured admission to a German university and obtained my student visa. Their knowledge of the German education system and visa requirements was impressive. They made what seemed impossible, possible. I am now studying engineering in Berlin and couldn\'t be happier.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 10,
    country: 'France',
    name: 'Aline Uwase',
    image: '',
    testimonial: 'Cardx Academia helped me navigate the complex French visa application process. Their attention to detail and thorough document preparation ensured my application was successful. They also assisted with booking my flight and provided valuable pre-departure guidance. I am now studying in Paris and loving every moment.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 11,
    country: 'UK',
    name: 'David Nsengimana',
    image: '',
    testimonial: 'I attended an international conference in London thanks to Cardx Academia. They handled my UK visa application and travel arrangements seamlessly. Their professionalism and efficiency made the entire process stress-free. I was able to focus on my conference presentation while they took care of all the logistics.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 12,
    country: 'Netherlands',
    name: 'Grace Ingabire',
    image: '',
    testimonial: 'Cardx Academia made my study abroad journey to the Netherlands smooth and successful. They helped me secure admission, obtain my student visa, and even found me affordable accommodation options. Their team goes above and beyond to ensure their clients succeed. I highly recommend their services.',
    type: 'text',
    videoUrl: null,
    thumbnail: null,
    scholarship: true
  },
  {
    id: 13,
    country: 'Sweden',
    name: 'Patrick Habimana',
    image: '',
    testimonial: 'I am currently studying in Sweden thanks to Cardx Academia. They guided me through the entire application process, helped me secure a scholarship, and assisted with my visa application. Their expertise in European education systems is unmatched. I am grateful for their support and would recommend them to anyone.',
    type: 'text',
    videoUrl: null,
    thumbnail: null,
    scholarship: true
  },
  {
    id: 14,
    country: 'Belgium',
    name: 'Sarah Mutoni',
    image: '',
    testimonial: 'Cardx Academia helped me attend a research conference in Brussels. They handled my Belgian visa application efficiently and provided excellent travel support. Their knowledge of European visa requirements saved me time and stress. I was able to present my research successfully thanks to their assistance.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 15,
    country: 'USA',
    name: 'James Mwiza',
    image: '',
    testimonial: 'I successfully obtained my US student visa with the help of Cardx Academia. Their team was professional, responsive, and knowledgeable about the F-1 visa process. They helped me prepare all documents, schedule my interview, and even provided interview preparation tips. I am now studying in New York.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 16,
    country: 'Canada',
    name: 'Ange Nyiramana',
    image: '',
    testimonial: 'Cardx Academia made my Canadian study permit application process incredibly smooth. They provided step-by-step guidance, helped me prepare all required documents, and followed up with IRCC on my behalf. Their support was invaluable, and I am now pursuing my studies in Toronto. Thank you for making my dream come true!',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 17,
    country: 'Germany',
    name: 'Eric Niyonsenga',
    image: '',
    testimonial: 'I attended a tech conference in Berlin with the assistance of Cardx Academia. They handled my German visa application and travel arrangements professionally. Their attention to detail and timely communication made the process effortless. I was able to network and learn from industry leaders thanks to their support.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 18,
    country: 'Switzerland',
    name: 'Diane Uwimana',
    image: '',
    testimonial: 'Cardx Academia helped me secure admission to a Swiss university and obtain my student visa. The Swiss visa process can be complex, but their team navigated it expertly. They also helped me understand the cost of living and provided valuable tips for student life in Switzerland. I am grateful for their guidance.',
    type: 'text',
    videoUrl: null,
    thumbnail: null,
    scholarship: true
  },
  {
    id: 19,
    country: 'Norway',
    name: 'Fabrice Nkurunziza',
    image: '',
    testimonial: 'I am studying in Norway thanks to Cardx Academia. They helped me secure a scholarship, obtain my residence permit, and prepare for my journey. Their knowledge of Nordic education systems and visa requirements is excellent. The entire process was smooth, and I am now pursuing my master\'s degree in Oslo.',
    type: 'text',
    videoUrl: null,
    thumbnail: null,
    scholarship: true
  },
  {
    id: 20,
    country: 'Italy',
    name: 'Claudine Mukeshimana',
    image: '',
    testimonial: 'Cardx Academia assisted me with my Italian student visa application. They were patient, thorough, and always available to answer my questions. They helped me prepare all documents in Italian and English, which was crucial for my application. I am now studying art history in Florence and loving it!',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 21,
    country: 'USA',
    name: 'Robert Nkurunziza',
    image: '',
    testimonial: 'I attended a business conference in San Francisco with Cardx Academia\'s help. They handled my US visitor visa application and travel arrangements efficiently. Their team provided excellent support throughout the process, and I was able to attend the conference without any issues. Highly professional service!',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 22,
    country: 'Denmark',
    name: 'Esther Uwamahoro',
    image: '',
    testimonial: 'Cardx Academia made my study journey to Denmark possible. They helped me secure admission, obtain my residence permit, and provided valuable guidance on living in Denmark. Their expertise in Nordic countries is impressive. I am now studying sustainable development in Copenhagen and couldn\'t be happier.',
    type: 'text',
    videoUrl: null,
    thumbnail: null,
    scholarship: true
  },
  {
    id: 23,
    country: 'Spain',
    name: 'Alexis Niyonshuti',
    image: '',
    testimonial: 'I successfully obtained my Spanish student visa with Cardx Academia\'s assistance. They helped me navigate the Spanish visa requirements and prepared all necessary documents. They also provided language learning resources and cultural tips. I am now studying in Barcelona and enjoying the experience.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 24,
    country: 'Canada',
    name: 'Rachel Uwase',
    image: '',
    testimonial: 'Cardx Academia helped me secure my Canadian work permit and assisted with my Express Entry application. Their knowledge of Canadian immigration policies is excellent. They provided personalized guidance and ensured all my documents were properly prepared. I am now working in Vancouver and grateful for their support.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 25,
    country: 'Finland',
    name: 'Daniel Nkurunziza',
    image: '',
    testimonial: 'I attended a research conference in Helsinki thanks to Cardx Academia. They handled my Finnish visa application and travel arrangements professionally. Their attention to detail and timely communication made the process smooth. I was able to present my research and network with international scholars.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 26,
    country: 'USA',
    name: 'Violette Uwimana',
    image: '',
    testimonial: 'Cardx Academia helped me secure admission to a US university and obtain my F-1 visa. Their team was knowledgeable, supportive, and always responsive. They guided me through every step, from university selection to visa interview preparation. I am now studying public health in Boston.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 27,
    country: 'Austria',
    name: 'Innocent Nsengimana',
    image: '',
    testimonial: 'I am studying in Austria thanks to Cardx Academia. They helped me secure admission, obtain my residence permit, and provided valuable guidance on Austrian education system. Their expertise in European countries is impressive. The entire process was smooth, and I am now pursuing my PhD in Vienna.',
    type: 'text',
    videoUrl: null,
    thumbnail: null,
    scholarship: true
  },
  {
    id: 28,
    country: 'Germany',
    name: 'Josiane Ingabire',
    image: '',
    testimonial: 'Cardx Academia assisted me with my German student visa and helped me secure a scholarship. Their team was professional, thorough, and always available. They made the complex German visa process manageable. I am now studying engineering in Munich and grateful for their excellent support.',
    type: 'text',
    videoUrl: null,
    thumbnail: null,
    scholarship: true
  },
  {
    id: 29,
    country: 'Portugal',
    name: 'Samuel Nkurunziza',
    image: '',
    testimonial: 'I successfully obtained my Portuguese student visa with Cardx Academia\'s help. They guided me through the application process and helped me prepare all required documents. Their knowledge of European visa requirements is excellent. I am now studying in Lisbon and enjoying my academic journey.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 30,
    country: 'USA',
    name: 'Chantal Uwamahoro',
    image: '',
    testimonial: 'Cardx Academia made my US study journey possible. They helped me secure admission to a top university, obtain my student visa, and provided excellent pre-departure support. Their team goes above and beyond to ensure success. I am now studying business administration in Chicago.',
    type: 'text',
    videoUrl: null,
    thumbnail: null
  },
  {
    id: 31,
    country: 'Israel',
    name: 'Hallelujah Amen',
    image: '',
    testimonial: 'HALLELUJAH AMEN has officially secured a Master\'s scholarship to study in Israel. We are proud of this milestone and honored to have supported her journey from application to visa processing.',
    type: 'video',
    videoUrl: '/videos/Amen_Testimony1.mp4',
    thumbnail: '',
    instagramEmbed: false,
    scholarship: true
  },
  {
    id: 32,
    country: 'Israel',
    name: 'Hallelujah Amen',
    image: '',
    testimonial: 'Amen has now arrived safely in Tel Aviv and was warmly received by our team in Israel. This marks the successful final step of her study-abroad journey.',
    type: 'video',
    videoUrl: '/videos/AMEN_arrival.MOV',
    thumbnail: '',
    instagramEmbed: false,
    scholarship: true
  },
  {
    id: 33,
    country: 'Canada',
    name: 'Kenny Ishimwe',
    image: '',
    testimonial: 'We\'re proud to celebrate another successful outcome at Cardx Academia. One of our valued applicants has officially received his Canadian student visa and is now set to continue his studies in Canada. In this testimony, Kenny shares how Cardx Academia supported him through the visa process.',
    type: 'video',
    videoUrl: '/videos/Kenny_Testimony.mp4',
    thumbnail: '',
    instagramEmbed: false
  },
  {
    id: 34,
    country: 'Canada',
    name: 'Kenny Ishimwe',
    image: '',
    testimonial: 'Kenny Ishimwe is on his way to Canada. This moment at Kanombe captures his departure as he begins the next chapter of his study-abroad journey with support from Cardx Academia.',
    type: 'video',
    videoUrl: '/videos/KANOMBE.mp4',
    thumbnail: '',
    instagramEmbed: false
  },
  {
    id: 35,
    country: 'Canada',
    name: 'Kenny Ishimwe',
    image: '/images/testimonials/kenny-ottawa-1.jpg',
    testimonial: 'Our applicant has now safely arrived in Canada. As part of our commitment to full support, we were pleased to welcome and pick him up directly from the airport in Ottawa. At Cardx Academia, we don\'t just process applications; we walk the journey with you.',
    type: 'photo',
    videoUrl: null,
    thumbnail: null,
    instagramEmbed: false
  },
  {
    id: 36,
    country: 'Canada',
    name: 'Kenny Ishimwe',
    image: '/images/testimonials/kenny-ottawa-2.jpg',
    testimonial: 'Kenny Ishimwe was warmly received by our team in Ottawa, Canada, one of the full-support services we provide beyond visa processing, including airport pickup and arrival assistance for our students.',
    type: 'photo',
    videoUrl: null,
    thumbnail: null,
    instagramEmbed: false
  }
];

export const offices = {
  rwanda: {
    label: 'Rwanda Office (Kigali)',
    country: '🇷🇼',
    address: '1st Floor, Door F1B-013D, Town Center Building (TCB), Kigali City',
    addressLines: [
      '1st Floor, Door F1B-013D,',
      'Town Center Building (TCB),',
      'Kigali City.',
    ],
    phones: [
      { display: '+250 788 603 451', tel: '+250788603451' },
      { display: '+250 787 420 838', tel: '+250787420838' },
    ],
  },
  burundi: {
    label: 'Burundi Branch (Bujumbura)',
    country: '🇧🇮',
    address: 'Bujumbura, Rohero II, White stone building/Bureau numéro 11',
    addressLines: [
      'Bujumbura, Rohero II,',
      'White stone building/Bureau numéro 11',
    ],
    phones: [
      { display: '+257 663 142 49', tel: '+25766314249' },
      { display: '+257 699 095 33', tel: '+25769909533' },
    ],
  },
};

export const officeLocations = [
  { value: offices.rwanda.address, label: `${offices.rwanda.label}: ${offices.rwanda.address}` },
  { value: offices.burundi.address, label: `${offices.burundi.label}: ${offices.burundi.address}` },
];

export const contactInfo = {
  email: 'info@cardxacademia.com',
  phone: '+250788603451',
  phoneDisplay: '+250 788 603 451',
  address: offices.rwanda.address + '.',
  offices,
};

export const footerLinks = [
  { name: 'Home', href: '/' },
  { name: 'Appointment', href: '/appointment' },
  { name: 'Services', href: '/services' },
  { name: 'Visa Applications', href: '/visa' },
  { name: 'Tour Registration', href: '/tour-registration' },
  { name: 'Testimonials', href: '/testimonials' },
  { name: 'Contact Us', href: '/contact' },
  { name: 'About', href: '/about' }
];
